import {
  PlacementContentDef,
  SSRTextPlacementContent,
  SSRTextPlacementContentContentTypeEnum
} from '@ads-ep/fetch-api-client';
import { SSRTextPlacementContentType } from './constructor-lookup/placement-constructor-lookup.util';

export function isSSRContent(content: PlacementContentDef): content is SSRTextPlacementContent{
  return (content.contentType === SSRTextPlacementContentType);
}
